/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Averaged move over `short_window_sessions` trading sessions.
 */
export type DailyNavDeliveryWindow = {
  /**
   * The session the window measures from -- a real trading session on the firm's calendar, never weekday arithmetic. Null on the since-last-valuation window when the company has no prior valuation.
   */
  prior_date: string | null;
  /**
   * The arithmetic mean of the contributors' own percent changes, as a signed fraction. Null when nothing contributed.
   */
  average_pct: string | null;
  /**
   * The threshold actually applied, as a fraction: the company override when there is one, otherwise the firm default. Null when neither is set, in which case nothing can breach.
   */
  threshold: string | null;
  /**
   * Where `threshold` came from: `company` (an override), `firm` (the inherited default), or `none`.
   */
  threshold_source: DailyNavDeliveryWindow.threshold_source;
  /**
   * The firm default, carried even when an override won. `threshold` is already the effective value, so it alone cannot say what an override departed from.
   */
  firm_threshold: string | null;
  /**
   * True when abs(average_pct) is over `threshold`. Absolute: a move far below the band is as much a reason to look as one far above.
   */
  exceeded: boolean;
};
export namespace DailyNavDeliveryWindow {
  /**
   * Where `threshold` came from: `company` (an override), `firm` (the inherited default), or `none`.
   */
  export enum threshold_source {
    COMPANY = 'company',
    FIRM = 'firm',
    NONE = 'none',
  }
}

